export default __webpack_public_path__ + "static/media/item_2@3x.f9e37387.webp";